import { create } from "zustand";

/**
 * Başarılı submit sonrası success ekranında gösterilen özet bilgi.
 * Yalnızca misafir kullanıcılar için kullanılır — login kullanıcılar
 * submit sonrası doğrudan ticket detay sayfasına yönlendirilir.
 */
export interface SupportSubmissionSummary {
  email: string;
  categoryLabelKey: string;
  issueLabelKey: string;
  emailSent: boolean;
  /** Backend'in ürettiği ticket kaydının id'si */
  ticketId?: string;
  /** Kullanıcıya gösterilen sıralı ticket numarası */
  ticketNumber?: number;
}

interface SupportStore {
  // Success ekranı state'i (misafir kullanıcı)
  lastSubmission: SupportSubmissionSummary | null;

  // Actions
  setLastSubmission: (submission: SupportSubmissionSummary) => void;
  clearLastSubmission: () => void;
}

export const useSupportStore = create<SupportStore>()((set) => ({
  lastSubmission: null,

  setLastSubmission: (submission) => set({ lastSubmission: submission }),
  clearLastSubmission: () => set({ lastSubmission: null }),
}));
